import React from 'react';
import { array } from 'prop-types';
import OfferFilesList from './OfferFilesList';

const propTypes = {
  files: array.isRequired,
};

const defaultProps = {
  files: [],
};

const OfferFiles = ({ files, collapsing }) => (
  <OfferFilesList
  collapsing={collapsing}
    className="offer-files"
    files={files.map(file => (
      <a href={file.link} className="offer-files-item" target="_blank">
        {file.title}
      </a>
    ))}
  />
);

OfferFiles.propTypes = propTypes;
OfferFiles.defaultProps = defaultProps;

export default OfferFiles;
